<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Veuillez patienter...</p>
        </div>
        <!--<CreditCardForm></CreditCardForm>-->
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import CreditCardForm from "./CreditCardRedirectForm";

import {get, call} from 'vuex-pathify'

export default {
    components: {CreditCardForm},
    mixins: [mixin, animation_engine_mixin, animation_step_style_mixin],
    computed: {
        match_token: get('func_data/match_token')
    },
    methods: {
        reset: call('form/reset'),
    },
    mounted() {
        if (this.match_token) {
            //timeout > 100 (stepflux mixin componentMounted() uwu )
            setTimeout(() => {
                console.log('component')
                axios.post(
                    '/create_payment',
                    {match_token: this.match_token}
                ).then((response) => {
                    location.href = response.data.redirect_url;
                }).catch((error) => {
                    this.reset();
                })
            },200)
        }
    }
}
</script>
